import { requestHandler } from "../lib/utils/network-client";

export function getDashboardStats() {
  return requestHandler("/dashboard", {
    method: "GET"
  });
}
